var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.5,
    height: 45.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF510D",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M-.001 0H45v45H-.001V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    d: "M22.499 2C33.821 2 43 11.178 43 22.5S33.821 43 22.499 43C11.178 43 2.002 33.822 2.002 22.5S11.178 2 22.499 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M33.541 27.51c-.194.196-.511.196-.706 0l-9.818-9.818-9.821 9.818c-.195.196-.511.196-.707 0-.196-.195-.196-.512 0-.707l9.908-9.906c-.018-.146.011-.295.125-.407.133-.135.324-.17.493-.119.17-.051.362-.016.497.119.112.112.141.261.123.408l9.906 9.905c.195.195.195.512 0 .707z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoupIcon);
export default __webpack_public_path__ + "static/media/goup-icon.9f944f655a7745d3265237d6d1b2f671.svg";
export { ForwardRef as ReactComponent };